<template>
    <div>
        <div class="row">
            <div class="col-lg-6 mb-1 mb-lg-0">
                <div class="row">
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Kanun 5084 Gelir Vergisi Terkin Oranı (%)</label>
                        <input class="form-control" v-model="value.GV_TERKIN" placeholder="Kanun 5048 Gelir Vergisi Terkin Oranı (%)" />
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Kanun 5084 SGK İşveren Terkin Oranı (%)</label>
                        <input class="form-control" v-model="value.ISVR_TERKIN" placeholder="Kanun 5084 SGK İşveren Terkin Oranı (%)" />
                    </div>
                    <div class="col-12 mb-1">
                        <b-form-checkbox class="mb-50" v-model="value.K5763_M20_TERKIN" value="E" unchecked-value="H">Kanun 5763 Madde 20 Terkin (SGK İşveren)</b-form-checkbox>
                        <b-form-checkbox class="mb-50" v-model="value.K5763_M24_TERKIN" value="E" unchecked-value="H">Kanun 5763 Madde 24 Terkin (Malulluk, Yaşlılık, Ölüm)</b-form-checkbox>
                        <b-form-checkbox value="E" v-model="value.K5921_GM9_TERKIN" unchecked-value="H">Kanun 5921 Geçici Madde 9 Terkin (SGK İşveren)</b-form-checkbox>
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Özürlü Peronel Terkin Oranı (SGK İşveren)(%)</label>
                        <input class="form-control" v-model="value.YEDEK1_TERKIN" placeholder="Özürlü Peronel Terkin Oranı (SGK İşveren)(%)" />
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Arge Terkin (SGK İşveren)(%)</label>
                        <input class="form-control" v-model="value.YEDEK2_TERKIN"  placeholder="Arge Terkin (SGK İşveren)(%)" />
                    </div>
                    <!-- <div class="col-12 mb-1">
                        <label class="form-label">Arge Tipi</label>
                        <div>
                            <b-form-radio inline value="I">Teknopark Arge</b-form-radio>
                            <b-form-radio inline value="M">Yerinde Arge</b-form-radio>
                        </div>
                    </div> -->
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Arge Muaf Oranı (Gelir Vergisi)(%)</label>
                        <input class="form-control" v-model="value.ARGE_MUAF_ORAN" placeholder="Arge Muaf Oranı (Gelir vergisi)(%)" />
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Arge Damga Vergisi Muaf Oranı (%)</label>
                        <input class="form-control" v-model="value.ARGE_DAMGAMUAF_ORAN" placeholder="Arge Damga Vergisi Muaf Oranı (%)" />
                    </div>
                    <div class="col-12 mb-1">
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K5921_EM2_TERKIN" unchecked-value="H">Kanun 5921 Ek Madde 2 Terkin (SGK İşveren)</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K6486_TERKIN" unchecked-value="H">Kanun 6486 SGK İşveren Terkini (%6)</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K6322_TERKIN_ISVEREN" unchecked-value="H">Kanun 6322 SGK İşveren Terkini</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K6322_TERKIN_ISCI" unchecked-value="H">Kanun 6322 SGK İşçi Terkini</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K6322_GV_TERKIN" unchecked-value="H">Kanun 6322 Gelir Vergisi Terkini</b-form-checkbox>
                        <!-- <b-form-checkbox class="mb-50" value="E" unchecked-value="H">İşveren İşsizlik Primi Teşviği</b-form-checkbox> -->
                        <b-form-checkbox class="mb-50" value="E" v-model="value.K6645_TERKIN" unchecked-value="H">Kanun 6645 Madde 28 SGK İşveren Terkin</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.KHK687_SGK_TERKIN" unchecked-value="H">687 nolu KHK SGK Terkini</b-form-checkbox>
                        <b-form-checkbox class="mb-50" value="E" v-model="value.KHK687_GV_TERKIN" unchecked-value="H">687 nolu KHK GV Terkini</b-form-checkbox>
                        <b-form-checkbox value="E" v-model="value.KHK687_DV_TERKIN" unchecked-value="H">687 nolu KHK DV Terkini</b-form-checkbox>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="border rounded px-1 pt-1 mb-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K6111_GM10_TERKIN" unchecked-value="H">Kanun 6111 Geçici Madde 10 Terkin (SGK İşveren)</b-form-checkbox>
                        </div>
                        <template v-if="value.K6111_GM10_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 6111 Geçici Madde 10 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K6111_GM10_TERKIN_TARIH" placeholder="Kanun 6111 Geçici Madde 10 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 6111 Geçici Madde 10 Terkin Süre</label>
                                <input class="form-control" v-model="value.K6111_GM10_TERKIN_SURE" placeholder="Kanun 6111 Geçici Madde 10 Terkin Süre" />
                            </div>
                            <!-- <div class="col-12 mb-1">
                                <b-form-checkbox value="E" unchecked-value="H">5/2023 için 6111'e dahil edilmesin</b-form-checkbox>
                            </div> -->
                        </template>
                    </div>     
                </div>
                <div class="border rounded px-1 pt-1 mb-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K4447_GM19_TERKIN" unchecked-value="H">Kanun 4447 Geçici Madde 19 Terkin</b-form-checkbox>
                        </div>
                        <template v-if="value.K4447_GM19_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 19 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K4447_GM19_TERKIN_TARIH" placeholder="Kanun 4447 Geçici Madde 19 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 19 Terkin Süre</label>
                                <input class="form-control" v-model="value.K4447_GM19_TERKIN_SURE" placeholder="Kanun 4447 Geçici Madde 19 Terkin Süre" />
                            </div>
                            <!-- <div class="col-12 mb-1">
                                <b-form-checkbox value="E" unchecked-value="H">5/2023 için 4447 geçici madde 19'a dahil edilmesin</b-form-checkbox>
                            </div> -->
                        </template>
                    </div>     
                </div>
                <div class="border rounded px-1 pt-1 mb-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K7166_M8_TERKIN" unchecked-value="H">Kanun 7166 Geçici Madde 8 Terkin</b-form-checkbox>
                        </div>
                        <template v-if="value.K7166_M8_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 7166 Geçici Madde 8 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K7166_M8_TERKIN_TARIH" placeholder="Kanun 7166 Geçici Madde 8 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 7166 Geçici Madde 8 Terkin Süre</label>
                                <input class="form-control" v-model="value.K7166_M8_TERKIN_SURE" placeholder="Kanun 7166 Geçici Madde 8 Terkin Süre" />
                            </div>
                        </template>
                    </div>     
                </div>
                <div class="border rounded px-1 pt-1 mb-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K4447_GM26_TERKIN" unchecked-value="H">Kanun 4447 Geçici Madde 26 Terkin</b-form-checkbox>
                        </div>
                        <template v-if="value.K4447_GM26_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 26 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K4447_GM26_TERKIN_TARIH" placeholder="Kanun 4447 Geçici Madde 26 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 26 Terkin Süre</label>
                                <input class="form-control" v-model="value.K4447_GM26_TERKIN_SURE" placeholder="Kanun 4447 Geçici Madde 26 Terkin Süre" />
                            </div>
                        </template>
                    </div>     
                </div>
                <div class="border rounded px-1 pt-1 mb-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K7256_M28_TERKIN" unchecked-value="H">Kanun 7256 Terkin </b-form-checkbox>
                        </div>
                        <template v-if="value.K7256_M28_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 7256 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K7256_M28_TERKIN_TARIH" placeholder="Kanun 7256 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 7256 Terkin Süre</label>
                                <input class="form-control" v-model="value.K7256_M28_TERKIN_SURE" placeholder="Kanun 7256 Terkin Süre" />
                            </div>
                        </template>
                    </div>     
                </div>
                <div class="border rounded px-1 pt-1 mb-1 mb-lg-0">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox value="E" v-model="value.K4447_M30_TERKIN" unchecked-value="H">Kanun 4447 Geçici Madde 30 Terkin</b-form-checkbox>
                        </div>
                        <template v-if="value.K4447_M30_TERKIN == 'E'">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 30 Terkin Başlangıç Tarihi</label>
                                <v-date-picker v-model="value.K4447_M30_TERKIN_TARIH" placeholder="Kanun 4447 Geçici Madde 30 Terkin Başlangıç Tarihi"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Kanun 4447 Geçici Madde 30 Terkin Süre</label>
                                <input class="form-control" v-model="value.K4447_M30_TERKIN_SURE" placeholder="Kanun 4447 Geçici Madde 30 Terkin Süre" />
                            </div>
                            <div class="col-12 mb-1">
                                <b-form-checkbox value="E" v-model="value.K4447_M30_DAHIL" unchecked-value="H">5/2023 için 4447 geçici madde 30'a dahil edilmesin</b-form-checkbox>
                            </div>
                        </template>
                    </div>     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox, BFormRadio } from 'bootstrap-vue'
export default {
    props:{
        value:Object
    },
    components:{
        BFormCheckbox,
        BFormRadio
    }
}
</script>

<style>

</style>